var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDentalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 9,
    fill: "url(#paint0_linear_19577_32877)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2795 13.876C13.4582 11.3443 16.4049 8.81244 21.1197 11.9771C25.8345 8.81199 28.7812 11.3439 29.9597 13.8762C30.8436 15.7751 29.9597 19.1509 29.3705 20.8389L26.1433 30.5684C26.0196 30.9416 25.5181 31.0039 25.3068 30.6724L23.0873 27.19C22.1701 25.751 20.0692 25.751 19.152 27.19L16.9219 30.6888C16.7124 31.0175 16.2232 30.9597 16.1053 30.5882C15.3895 28.3312 14.0856 23.888 12.8688 20.8389C11.4544 17.2942 11.329 15.9174 12.2795 13.876Z",
    stroke: "#2D60B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19577_32877",
    x1: 21,
    y1: -7.52509e-7,
    x2: 21,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentalIcon);
export default __webpack_public_path__ + "static/media/dentalIcon.1921ef8ec54a5f3859b302db563414a6.svg";
export { ForwardRef as ReactComponent };